import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { axiosClient } from "../utils/api";
import Loding from "../components/public/loding";
import NavBar from "../components/public/NavBar";

export default function Home() {
  let [login, setlogin] = useState(false);
  let [loding, setloding] = useState(true);
  useEffect(() => {
    axiosClient
      .get("/user/auth")
      .then((res) => (res.status !== 201 ? setlogin(false) : null))
      .catch(() => setlogin(true))
      .finally(() => setloding(false));
  }, []);
  if (loding) return <Loding />;
  return (
    <>
      {login ? (
        <NavBar login={true} logout={false} />
      ) : (
        <NavBar login={false} logout={true} />
      )}
      <Container className="container">
        <Row>
          <Col>
            <h1>apply mangement</h1>
            <p>
              موقعي هو موقع يساعدك على إدارة تقديمات لإدارة الخصة بسيرفرات
              الديسكورد. إذا كنت تريد أن تصبح مديراً لسيرفر ديسكورد، فهذا الموقع
              يمكنك من إنشاء تقديمة تحتوي على معلومات عن نفسك وخبرتك ورؤيتك
              للسيرفر. يمكنك أيضاً رؤية تقديمات الآخرين والتصويت عليها أو
              التعليق عليها. هذا الموقع يهدف إلى جعل عملية اختيار المديرين أكثر
              شفافية وديمقراطية وجودة. لكي تستخدم هذا الموقع، عليك أولاً التسجيل
              بحساب ديسكورد الخاص بك. بعد ذلك، ستظهر لك قائمة بالسيرفرات المتاحة
              لإدارتها. اختر السيرفر الذي ترغب في التقديم له، واملأ النموذج الذي
              يطلب منك بيانات شخصية واسئلة محددة. عند انتهائك من التقديمة، ستظهر
              في صفحة السيرفر حيث يمكن للأعضاء الآخرين رؤيتها والتفاعل معها. كل
              تقديمة لها مدة زمنية محددة، وبعد انتهائها، سيتم اختيار المدير
              الجديد بناءً على عدد الأصوات والتعليقات. هذا الموقع هو موقع مجاني
              وآمن وسهل الاستخدام. إذا كان لديك أي استفسار أو اقتراح أو شكوى،
              يمكنك التواصل معنا عبر البريد الإلكتروني أو الديسكورد. نحن نسعى
              دائماً لتحسين خدماتنا والاستماع إلى آراء المستخدمين. نأمل أن يعجبك
              موقعنا وأن تستفيد منه.
            </p>
          </Col>
        </Row>
      </Container>
    </>
  );
}
